export default __webpack_public_path__ + "static/media/warning--road-widens-right--g1.0c6d1992.png";